export class Console {
  static readonly #baseStyle = [
    'font-family: consolas, segoe ui',
    'font-size: 14px',
    'letter-spacing: 1px',
    'padding:3px 5px',
    'border-radius: 4px',
    'margin:1px 5px 1px 0',
    'color:white'
  ];

  static readonly #errorStyle = Console.#baseStyle.concat(['background:#c40606']);
  static readonly #warnStyle = Console.#baseStyle.concat(['background:#d1580b']);
  static readonly #infoStyle = Console.#baseStyle.concat(['background:#0561b2']);
  static readonly #logStyle = Console.#baseStyle.concat(['background:#18b885']);

  static readonly log = console.log.bind(window.console, '%c%s', Console.#logStyle.join(';'));
  static readonly logInfo = console.info.bind(window.console, '%c%s', Console.#infoStyle.join(';'));
  static readonly logWarning = console.warn.bind(window.console, '%c%s', Console.#warnStyle.join(';'));
  static readonly logError = console.error.bind(window.console, '%c%s', Console.#errorStyle.join(';'));
}
